import React, { useState, useEffect, useMemo } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { FormSelectionIcon } from 'components/WorkviewManager/PaperProcessModel/FormSelectionList'
// import { FilingSourceTypeIds } from '../WorkviewManager'
import { SearchBox } from '@tecuity/granite-ui/SearchBox'
import { Spinner } from 'components/Loaders/Loaders'
import * as api from '../../../requests'
import { SET_RECORD_TO_AMEND } from '../../WVManager/Workview2Reducer'
import { ContextBar } from '@tecuity/granite-ui/ContextBar'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
// import { SearchBox } from '@tecuity/granite-ui/SearchBox'
import Cross from '@tecuity/sos-icons/react/cross-heavy'

const OrdersFormList = ({ orderFilingXrefs, selectedSourceType }) => {
  const {
    selectedRow,
    staffDraft,
    showPaperFilingErrorMessage,
    paperFilingErrorMessage,
    orderForms,
  } = useSelector((state) => state.workview2, shallowEqual)
  const { activeSourceTypes } = useSelector((state) => state.app, shallowEqual)
  const [formFilter, setFormFilter] = useState('')
  const [recordForms, setRecordForms] = useState([])
  const dispatch = useDispatch()

  useEffect(() => {
    if (selectedSourceType !== 0 && selectedRow.RecordToAmend) {
      api.GET_AVAILABLE_ORDER_FILINGS_STAFF(
        selectedRow.RecordToAmend.SourceID,
        activeSourceTypes.find((type) => type.SourceTypeId === +selectedSourceType).ModuleName,
        (newForms) => {
          setRecordForms(newForms)
        },
        (err) => {
          console.error(err)
        }
      )
    }
  }, [selectedRow, selectedSourceType, activeSourceTypes])

  const filteredWizards = useMemo(() => {
    const wizardList = []
    const FormDefinitionIDs = new Set()

    orderForms.forEach((option) => {
      option.forms.forEach((form) => {
        if (+selectedSourceType === 0) {
          if (!FormDefinitionIDs.has(form.FormDefinitionID)) {
            if (!formFilter || form.FormName.toLowerCase().includes(formFilter.toLowerCase())) {
              const xref = orderFilingXrefs.find(
                (x) => x.FormDefinitionId === form.FormDefinitionID
              )
              if (xref && xref.SourceTypeId === 0) {
                const wizard = { ...form }
                wizard.amendmentTypeID = option.value
                wizardList.push(wizard)
                FormDefinitionIDs.add(form.FormDefinitionID)
              }
            }
          }
        } else {
          //   {
          //     "AMENDMENT_TYPE_ID": 11,
          //     "AMENDMENT_TYPE_V_DESCR": "Conversion Filing",
          //     "FORM_DEFINITION_ID": 9474,
          //     "TITLE": "Statement of Conversion (In) and Certificate of Organization",
          //     "DESCR": "Use this form for an entity not currently registered to convert it and submit the Certificate of Organization."
          // }
          if (!FormDefinitionIDs.has(form.FormDefinitionID)) {
            if (!formFilter || form.FormName.toLowerCase().includes(formFilter.toLowerCase())) {
              if (recordForms.find((rForm) => rForm.FORM_DEFINITION_ID === form.FormDefinitionID)) {
                const wizard = { ...form }
                wizard.amendmentTypeID = option.value
                wizardList.push(wizard)
                FormDefinitionIDs.add(form.FormDefinitionID)
              }
            }
          }
        }
      })
    })
    return wizardList.sort((a, b) => {
      return a.FormName > b.FormName ? 1 : -1
    })
  }, [orderForms, formFilter, selectedSourceType, selectedRow, recordForms, orderFilingXrefs])

  return (
    <div>
      {selectedRow.RecordToAmend && (
        <div
          style={{
            textAlign: 'center',
            minWidth: '400px',
            padding: '15px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <ContextBar elevation="high">
            <ContextButton
              leftIcon={
                <div className="button-icon">
                  {' '}
                  <Cross />{' '}
                </div>
              }
              variant="danger"
              onClick={() => {
                dispatch({ type: SET_RECORD_TO_AMEND, record: null })

                // dispatch({ type: SET_PAPER_FILING_ERROR_MESSAGE, paperFilingErrorMessage: '' })
              }}
              customCss={''}
            >
              Cancel
            </ContextButton>
            <span className="primary">
              <h1 style={{ fontWeight: 'bold' }}>Order for:</h1>{' '}
              {selectedRow.RecordToAmend.Name ||
                selectedRow.RecordToAmend['Trademark Name'] ||
                selectedRow.RecordToAmend['Filing Number']}
            </span>
          </ContextBar>
        </div>
      )}
      {showPaperFilingErrorMessage && (
        <div
          style={{
            textAlign: 'center',
            width: '100%',
            height: '92.4px',
          }}
        >
          <h1 style={{ padding: '15px', fontWeight: 'bold' }}>{paperFilingErrorMessage}</h1>
        </div>
      )}
      <div className="filingSelectButtonWrapper" style={{ marginTop: '8px' }}>
        <SearchBox
          placeholder={'Filter by form name'}
          value={formFilter}
          onChange={(e) => setFormFilter(e)}
          showClearButton={false}
          showSearchButton={false}
        />
      </div>
      <div className="icon-wrapper">
        {filteredWizards.length > 0 && (
          <React.Fragment>
            {staffDraft && (
              <React.Fragment>
                <h2>Continue working from draft</h2>
                <div className="form-blocks paper-processed-wizard-item-wrapper">
                  <FormSelectionIcon
                    staffDraft
                    formName={staffDraft.FormTitle}
                    value={staffDraft.FormDefinitionId}
                    selectedRow={selectedRow}
                    form={{
                      FormDefinitionID: staffDraft.FormDefinitionId,
                      FormTitle: staffDraft.FormTitle,
                      filingTypeID: staffDraft.FilingTypeId,
                      amendmentTypeID: staffDraft.AmendmentTypeId,
                      IsInitialFiling: !!staffDraft.AmendmentTypeId,
                    }}
                  />
                </div>
              </React.Fragment>
            )}
            <h2>{staffDraft ? 'Discard draft and select a new form' : 'Select a form'}</h2>
            <div className="form-blocks paper-processed-wizard-item-wrapper">
              {filteredWizards.map((item, i) => (
                <FormSelectionIcon
                  key={i}
                  formName={item.FormName}
                  value={item.FormDefinitionID}
                  selectedRow={selectedRow}
                  form={item}
                />
              ))}
            </div>
          </React.Fragment>
        )}
        {filteredWizards.length === 0 && !formFilter && (
          <div
            style={{
              height: '200px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            className="form-blocks"
          >
            <div>
              <Spinner className="page-loader" themeColor="neutral" />
            </div>
          </div>
        )}
        {filteredWizards.length === 0 && formFilter && (
          <div
            style={{
              textAlign: 'center',
              width: '100%',
              height: '92.4px',
            }}
          >
            <h1 style={{ padding: '15px', fontWeight: 'bold' }}>
              No forms match filtration criteria...
            </h1>
          </div>
        )}
      </div>
    </div>
  )
}

export default OrdersFormList
